import { FC } from 'react';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';
import DividendsTableRow from './DividendsTableRow';

const DividendsTableBody: FC = () => {
  const { data } = useDividendsDistributionModal();

  const hasData = data.dividends?.length > 0;

  const rows = data.dividends!.map((dividend, index) => (
    <DividendsTableRow
      // eslint-disable-next-line react/no-array-index-key
      key={`dividend-row-${index}`}
      index={index}
      dividend={dividend}
    />
  ));

  return <TableBody hasData={hasData} content={rows} noDataMessage="" />;
};

export default DividendsTableBody;
